define('modules/pathfinder',["jquery", "app", "astar"], function($, App, astar) {
    var Graph = astar.Graph;
    astar = astar.astar;

    //Clean the path to remove unnecessary points
    function cleanRoute(routePoints) {
        /** Logic : 
            get the first and last points of a straight line removing all points in between
        **/
        var finalPoints = [];
        var runningSlope = null;//Currently running slope, we will detect path turns at a point if the current slope is not running slope
        var slope;//Slope of current point to last point

        for(var i = 0; i < routePoints.length ; i++) {
            if(i==0) {
                //Add the first point of path to route without any conditions
                finalPoints.push(routePoints[i]);
                continue;
            }

            //Get the slope between current point and previous point
            slope = getSlope(routePoints[i], routePoints[i-1]);
            if(runningSlope != null && slope != runningSlope) {
                //New turn,save the point where straight line ends
                finalPoints.push(routePoints[i-1]);
            }

            if(i == routePoints.length-1) {
                //Add the last point of path to route without any conditions
                finalPoints.push(routePoints[i]);
            }
            runningSlope = slope;
        }

        return finalPoints;
    }

    //Calculate slope of 2 given points
    function getSlope(p1, p2) {
        return Number(Number((p2.y - p1.y)/(p2.x - p1.x)).toFixed(2));
    }

    function getClosestReachableCell(point, grid) {
        var gridCell = grid[point[0]][point[1]];
        var shifts = [[0,-1],[-1,0],[1,0],[0,1],[-1,-1],[1,1],[1,-1],[-1,1]];
        var shift;

        while(shifts.length && (!gridCell || gridCell.isWall())) {
            shift = shifts.shift();
            var p1 = point[0] + shift[0];
            var p2 = point[1] + shift[1];
            gridCell = null;
            if(typeof grid[p1] != 'undefined' && typeof grid[p1][p2] != 'undefined') {
                gridCell = grid[p1][p2];
            }
        }

        if(!shifts.length && (!gridCell || gridCell.isWall())) {
            gridCell = grid[point[0]][point[1]];
        }
        return gridCell;
    }

    return {
        getPath : function(canvas, source, targets) {
            var traversableArea = new Graph(canvas, {
                diagonal : true
            });

            if(!$.isArray(targets[0])) {
                targets = [targets];
            }

            var actualSource;
            source = source.map(Number);
            actualSource = source.slice(0);
            source = source.map(function(c){return Math.floor(c);});

            var unavailablePath;
            var pathAvailable = false;
            //Get cell object from the traversable path grid at the position of source
            var start = getClosestReachableCell(source, traversableArea.grid);

            var results = targets.map(function(target, i) {
                target = target.map(Number);

                var actualTarget = target.slice(0);
                target = target.map(function(c){return Math.floor(c);});

                //Get cell object from the traversable path grid at the position of target
                var end = getClosestReachableCell(target, traversableArea.grid);

                //Compute path and return target index and path
                var path =  astar.search(traversableArea, start, end);

                if(path.length) {
                    pathAvailable = true;
                } else if(!pathAvailable) {
                    var newpath = astar.search(traversableArea, start, end, {closest : true});
                    if(newpath.length && (!unavailablePath || newpath.length < unavailablePath.length)) {
                        unavailablePath = {
                            target : actualTarget,
                            path : newpath,
                            length : newpath.length
                        };
                    }
                }
                return {
                    target : actualTarget,
                    path : path,
                    length : path.length
                };
            });

            // Sort the array of paths(to each target) in ascending order and take first value to get the least path
            var result = results.sort(function(a,b){
                return a.length - b.length;
            }).filter(function(r){
                return !!r.length;
            })[0];

            if(!result) {
                result = unavailablePath;
                if(!result) {
                    result = {
                        target : targets[0],
                        path : [],
                        length : 0
                    };
                }
            }

            if(result.length > 1) {
                //Last but one point used to detect running slope of path
                var p1 = result.path[result.length - 2];
                //Last point of the path
                var p2 = result.path[result.length - 1];

                //Check if line is crossing the target point and remove last point
                var d1 = p2.x - result.target[0] + 0.5;
                var d2 = p1.x - result.target[0] + 0.5;
                if(d1 == 0 || d1/Math.abs(d1) != d2/Math.abs(d2)) {
                    result.path.pop();
                } else {
                    var d1 = p2.y - result.target[1] + 0.5;
                    var d2 = p1.y - result.target[1] + 0.5;
                    if(d1 == 0 || d1/Math.abs(d1) != d2/Math.abs(d2)) {
                        result.path.pop();
                    }
                }
                result.path = cleanRoute(result.path);
            }

            result.path.unshift({x: actualSource[0], y : actualSource[1]});
            result.path.push({x: result.target[0], y : result.target[1]});

            return result;
        }
    };
});
